export default __webpack_public_path__ + "static/media/p3-accessory.0dcdbcbc.svg";